<template>
  <div v-easyadmin="easyadminId" 
    class="w-100 themed-item"
    :class="[contentType, {'bg-vodafone': content.theme == 'dark' && !content.background_color && !content.background_image}]" 
    v-if="isContentVisibleToUser()" 
    :style="[theme]" slide-two-col-component
  >
    <div class="position-relative overflow-hidden container h-100 bg-cover-center" :style="{'background-image': getContentResponsiveImageURL('background_image')}">
      <div v-if="backgroundVideoUrl" class="position-absolute-center">
        <video loop muted webkit-playsinline playsinline autoplay ref="video" class="w-100 h-100">
          <source :src="expandUrl(backgroundVideoUrl)" type="video/mp4">
        </video>
      </div>
      <div class="row justify-content-center h-100" :style="contentStyle">
        <div class="col-12 col-lg-8 d-flex flex-column px-sm-4 px-md-3 text-column" :class="textColumnClasses">
          <div 
            v-if="content.background_image || backgroundVideoUrl"
            class="overlay d-md-none" 
            :class="`overlay--${content.vertical_align || 'top'}`"
          ></div>
          <simple-text-component 
            :content="textContent"
            :opt-container-content="containerContent"
            :active-story="activeStory"
          ></simple-text-component>
          <div v-if="content.image && content.image.url" class="slide-image-container" :class="imageClasses">
            <div class="image-background bg-black"></div>
            <img :src="content.image.url" :class="content.image_class" class="image" slide-image />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fandomBasicMixin, fandomExtendedMixin } from "src/modules/fandom_mixins_module.js";
import anime from 'animejs/lib/anime.es.js';

export default {
  mixins: [fandomBasicMixin, fandomExtendedMixin],
  props: {
    activeStory: {
      type: Boolean
    }
  },
  data: () => {
    return {
      imageAnimation: null
    }
  },
  methods: {
    getContentResponsiveImage: Fandom.getContentResponsiveImage,
    getContentResponsiveImageURL: Fandom.getContentResponsiveImageURL,
  },
  mounted() {
    this.imageAnimation = anime({
      targets: '.slide-image-container > *',
      opacity: {
        value: [0, 1],
        easing: 'linear',
        duration: 500,
      },
      translateY: {
        value: ['85%', 0],
        easing: 'easeOutQuart',
        duration: 1000,
      },
      autoplay: false,
      duration: 1000,
      delay: anime.stagger(200)
    });
  },
  watch: {
    activeStory(value) {
      if (value) {
        this.imageAnimation.play();
      } else {
        setTimeout(() => this.imageAnimation.seek(0), 500);
      }
    }
  },
  computed: {
    backgroundVideoUrl() {
      const videoDesktop = this.content.background_video?.url ?? false;
      if (globalState.viewport?.xs) {
        return this.content.background_video_mobile?.url ?? videoDesktop;
      } else {
        return videoDesktop;
      }
    },
    imagePosition() {
      return this.content.image_position ?? (this.content.vertical_align == "end" ? "top" : "bottom");
    },
    imageClasses() {
      return [
        this.imagePosition
      ];
    },
    contentStyle() {
      const style = {};

      if (!this.content.theme) {
        style["color"] = this.content.text_color ? this.content.text_color : "inherit";
      }

      if (this.content.background_color && !this.content.background_image) {
        style["background-color"] = this.content.background_color;
      }

      return style;
    },
    textColumnClasses() {
      let verticalAlign = this.content.vertical_align ?? "top";
      if (this.content.hasOwnProperty("image_position")) {
        verticalAlign =  this.imagePosition == "top" ? (globalState.viewport?.xs ? "center" : "end") : "top";
      } else if (this.content.show_arrow) {
        verticalAlign = "top";
      }

      return [
        `justify-content-${verticalAlign}`
      ];
    },
    textContent() {
      const {background_color, ...rest} = this.content;
      return rest;
    }
  },
};
</script>

<style lang="scss" scoped>
[slide-two-col-component] {
  background-color: var(--theme-background);
  color: var(--theme-color);

  video {
    object-fit: cover;
  }

  .text-column {
    z-index: 1;
    padding-top: var(--navigation-height);
    padding-bottom: var(--navigation-height);
  }

  .overlay {
    position: absolute;
    left: 0;
    right: 0;
    height: 50%;
    opacity: .75;

    &--top {
      top: 0;
      background: linear-gradient(180deg, rgba(0, 0, 0, .65) 0%, rgba(0, 0, 0, 0) 100%);
    }
    
    &--bottom {
      bottom: 0;
      background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, .65) 100%);
    }
  }

  .top {
    top: 0;
  }

  .bottom {
    bottom: 0;
  }
    
  .slide-image-container {
    display: flex;
    position: absolute;
    right: 0;
    left: 0;
    z-index: -1;

    .image {
      aspect-ratio: 16/9;
      object-fit: cover;

      @include media-breakpoint-up(md) {
        width: 75% !important;
      }
    }

    .image-background {
      position: absolute;
      translate: 0 -4rem;
      width: 40%;
      aspect-ratio: 1/1;
      z-index: -1;
    }

    &.top {
      justify-content: end;
      margin: 0 1rem;

      .image {
        width: calc(100% - 4rem);
      }

      .image-background {
        left: 0;
      }
    }

    &.bottom {
      .image {
        width: 100%;
      }

      .image-background {
        right: 0;
      }
    }
  }
}
</style>
